<!--
    描述：顶部多选筛选栏
    时间：2020-06-18
    Created by yefan
-->
<template>
    <div class="filter-main">
        <div class="filter-item"
             v-for="(item, index) in filterColumns"
             :key="'row' + index">
            <div class="left-text">{{ item.sname }}</div>
            <ul class="right-list">
                <li class="check-all"
                    :class="{'active-item': item.checkAll}"
                    @click="hanldeClickAll(item)"><span>全部</span></li>
                <li class="check-item text-overflow"
                    v-for="(m, n) in item.list"
                    :key="'list' + n"
                    :class="{'active-item': m.checked}"
                    @click="handleClick(item, m)"><span>{{ m.label }}</span></li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            // 行筛选数组
            columns: {
                type: Array,
                default: () => {
                    return []
                }
            }
        },
        data() {
            return {
                filterColumns: [],
                status: true,
                timer: null
            }
        },
        created() {
            this.setDefaultList()
        },
        methods: {
            // 点击高亮
            handleClick(row, item) {
                this.status = false;
                item.checked = !item.checked;

                // 全选处理
                let list = row.list.filter(x => x.checked);
                row.checkAll = list.length === 0 ? true : false

                this.doDelay()
            },

            // 点击全部
            hanldeClickAll(row) {
                row.checkAll = !row.checkAll;
                if (row.checkAll) {
                    row.list.map(x => x.checked = false)
                }
                // 延迟防抖事件
                this.doDelay()
            },

            // 延迟函数
            doDelay() {
                // 如果此时定时器在， 清除
                if (this.timer) {
                    clearTimeout(this.timer)
                }

                // 没继续点击后 做操作处理
                this.timer = setTimeout(() => {
                    this.status = true
                    if (this.status) {
                        this.backList()
                    }
                }, 1000)
            },

            // 返回参数
            backList() {
                let arr = []
                this.filterColumns.forEach(x => {
                    if (x.checkAll) {
                        let obj = {
                            sname: x.sname,
                            list: []
                        }
                        arr.push(obj)
                    } else {
                        let _list = x.list.filter(y => y.checked)
                        let obj = {
                            sname: x.sname,
                            list: [..._list]
                        }
                        arr.push(obj)
                    }
                })
                this.$emit('doFilter', arr)
                // console.log(arr)
            },

            // 设置默认数组
            setDefaultList() {
                // 年份数组
                let price_type_dict = [
                    {
                        label: '信息价',
                        value: '1',
                        checked: false
                    },
                    {
                        label: '市场价',
                        value: '2',
                        checked: false
                    }
                ]
                // 年份数组
                let year_dict = [
                    {
                        label: '2020年',
                        value: '2020',
                        checked: false
                    },
                    {
                        label: '2019年',
                        value: '2019',
                        checked: false
                    },
                    {
                        label: '2018年',
                        value: '2018',
                        checked: false
                    },
                    {
                        label: '2017年',
                        value: '2017',
                        checked: false
                    }
                ]

                // 地区数组
                let area_dict = [
                    {
                        label: '合肥',
                        value: '340100',
                        checked: false
                    },
                    {
                        label: '芜湖',
                        value: '340200',
                        checked: false
                    },
                    {
                        label: '蚌埠',
                        value: '340300',
                        checked: false
                    },
                    {
                        label: '淮南',
                        value: '340400',
                        checked: false
                    },
					{
						label: '马鞍山',
						value: '340500',
						checked: false
					},
					{
						label: '淮北',
						value: '340600',
						checked: false
					},
					{
						label: '铜陵',
						value: '340700',
						checked: false
					},
					{
						label: '安庆',
						value: '340800',
						checked: false
					},
					{
						label: '黄山',
						value: '341000',
						checked: false
					},
					{
						label: '滁州',
						value: '341100',
						checked: false
					},
					{
						label: '阜阳',
						value: '341200',
						checked: false
					},
					{
						label: '宿州',
						value: '341300',
						checked: false
					},
					{
						label: '六安',
						value: '341500',
						checked: false
					},
					{
						label: '亳州',
						value: '341600',
						checked: false
					},
					{
						label: '池州',
						value: '341700',
						checked: false
					},
                    {
                        label: '宣城',
                        value: '341800',
                        checked: false
                    },
                ]

                let default_list = [
                    {
                        sname: '类型：',
                        checkAll: true,
                        list: price_type_dict
                    },
                    {
                        sname: '年份：',
                        checkAll: true,
                        list: year_dict
                    },
                    {
                        sname: '地区：',
                        checkAll: true,
                        list: area_dict
                    }
                ]
                this.filterColumns = this.columns.length === 0 ? default_list : this.columns
            }
        },
        computed: {}
    }
</script>

<style scoped lang="less">
    .filter-main {
        @activeColor: #409eff;

        padding: 5px 0;
        min-width: max-content;

        .filter-item {
            display: flex;
            height: 28px;
            line-height: 28px;
            font-size: 14px;
        }

        .left-text {
            width: 70px;
            padding: 0 10px;
            text-align: right;
        }

        .right-list {
            flex: 1;

            .check-all {
                display: inline-block;
                cursor: pointer;
                margin-right: 15px;
                vertical-align: top;
            }

            .check-item {
                cursor: pointer;
                margin: 0 10px;
                width: 56px;
                display: inline-block;
                padding: 0 5px;
            }

            .active-item {
                span {
                    color: @activeColor;
                    font-weight: 700;
                }
            }
        }
    }
</style>
